import BillingEmptyState from 'billing/components/BillingEmptyState'
import { Task } from 'mobx-task'
import React from 'react'
import { observer } from 'mobx-react'
import Button from 'components/Button'

interface PaymentMethodsEmptyState {
  canAddPaymentMethod: boolean
  onNewPaymentMethod: Task<unknown[], unknown>
}

export default observer(function PayoutMethodsEmptyState({
  canAddPaymentMethod,
  onNewPaymentMethod,
}: PaymentMethodsEmptyState) {
  return (
    <BillingEmptyState
      title="There are no Payment Methods"
      subtitle="No payment methods have been set up."
    >
      {canAddPaymentMethod && (
        <Button
          disabled={onNewPaymentMethod.pending}
          loading={onNewPaymentMethod.pending}
          type="primary"
          onClick={() => onNewPaymentMethod()}
          data-test="add-new-payment-method-button"
        >
          Add New Payment Method
        </Button>
      )}
    </BillingEmptyState>
  )
})
